// extracted by mini-css-extract-plugin
module.exports = {"control":"CarsCheckout_control__3t2ul","wrapper":"CarsCheckout_wrapper__vvt8J","confirm":"CarsCheckout_confirm__26jUR","price":"CarsCheckout_price__1HJT6"};